/**
 * PDPA consent vocabulary (CLAUDE.md §8, domain-model §1).
 *
 * The channel is how the customer gave or withdrew consent. It is a fixed list
 * (Nick, 4 Oct 2026) rather than free text so the history can be read and
 * reported on: "WhatsApp", "whatsapp" and "WA" are one channel, not three.
 * The column stays VARCHAR(24), so adding a channel here needs no migration.
 */
export const CONSENT_CHANNELS = ['IN_PERSON', 'PHONE', 'WHATSAPP', 'EMAIL', 'WEB_FORM', 'SMS'] as const;
export type ConsentChannel = (typeof CONSENT_CHANNELS)[number];

export const CONSENT_PURPOSES = ['MARKETING', 'SERVICE_REMINDER', 'SURVEY'] as const;
export type ConsentPurpose = (typeof CONSENT_PURPOSES)[number];

export function isConsentChannel(value: string): value is ConsentChannel {
  return (CONSENT_CHANNELS as readonly string[]).includes(value);
}
